import { useKeycloak } from "@react-keycloak/web";

import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import ProtectedRoutes from "./protectedRoutes";

const Routes = (props) => {
  const { keycloak } = useKeycloak();
  localStorage.setItem("qjumpers.publicui.auth.token", keycloak.token);

  return <>{!!keycloak.authenticated && <Route path="/*" render={() => <ProtectedRoutes {...props} />} />}</>;
};

export default Routes;
